<template>
  <v-dialog
    :eager="eager"
    v-model="show"
    @keydown.esc="closeOnEscape()"
    persistent
    scrollable
    :fullscreen="fullscreen"
    :max-width="maxWidth"
  >
    <v-card class="rounded-lg">
      <v-card-title v-if="title" class="py-3 px-4 d-flex align-center">
        <v-spacer />

        <div class="d-flex align-center">
          <span class="headline font-weight-medium mr-2 flex-grow-1">{{ title }}</span>
          <v-tooltip bottom v-if="infoText">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="ma-0 pa-0">
                <v-icon style="position:initial" class="mb-1">mdi-information</v-icon>
              </v-btn>
            </template>
            <span>{{ infoText }}</span>
          </v-tooltip>
        </div>

        <v-spacer />

        <v-icon aria-label="Close" @click.prevent="onCancel()">
          mdi-close</v-icon
        >
      </v-card-title>

      <v-card-text class="px-4 py-2">
        <div class="text-center py-8" v-if="loadingContent">
          <v-progress-circular
            color="primary"
            size="100"
            indeterminate
          ></v-progress-circular>
        </div>
        <slot v-else />
      </v-card-text>
      <v-card-actions v-if="!hideActions" class="px-4 py-3">
        <div v-if="$slots.extra" class="extra-content-wrapper">
            <slot name="extra" />
        </div>
        <slot name="footer" />
        <v-spacer></v-spacer>
        <v-btn
          v-if="showCancelButton"
          small
          class="pa-4 text-capitalize font-weight-regular display-1"
          @click.prevent="onCancel()"
          >{{ closeText }}</v-btn
        >
        <v-btn
          v-if="showConfirmButton"
          color="primary"
          small
          class="pa-4 text-capitalize font-weight-regular display-1"
          :loading="loading"
          @click.prevent="onConfirm()"
          >{{ okText }}</v-btn
        >
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
    name: 'ModalBase',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        closeWithEscape: {
            type: Boolean,
            default: true,
        },
        showConfirmButton: {
            type: Boolean,
            default: true,
        },
        showCancelButton: {
            type: Boolean,
            default: true,
        },
        eager: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            type: [String, Number],
            default: '600',
        },
        title: {
            type: String,
            default: '',
        },
        closeText: {
            type: String,
            default: function () {
                return this.$t('Close');
            },
        },
        okText: {
            type: String,
            default: function () {
                return this.$t('Save');
            },
        },
        loadingContent: {
            type: Boolean,
            default: false,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        infoText: {
            type: String,
            default: '',
        },
        hideActions: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        closeOnEscape() {
            if (this.closeWithEscape) {
                this.show = false;
            }
        },
        onCancel() {
            this.$emit('on-cancel');
        },
        onConfirm(event) {
            this.$emit('on-confirm');
        },
        progress(show) {
            this.loading = show;
        },
    },
};
</script>
<style scoped>
.extra-content-wrapper {
  width: 100%;
  margin-bottom: 8px;
}
</style>